export default {
  loading: false,
  receipts: {
    list: [],
    loading: false
  },
  list: {},
  selectedReceipt: {},
  pagination: {
    items: 0,
    pages: 0
  },
  detailsReceipt: {},
  detailsSelectedReceipts: []
};
